import React from 'react'

/**
 * Inline error banner matching the dashboard's destructive-state pattern
 * (light red bg + error text). Use for non-blocking load / save failures
 * at the top of a page or section. For transient toasts, use the
 * NotificationContext instead.
 */
export interface ErrorBannerProps {
  message: string
  className?: string
}

export function ErrorBanner({ message, className = '' }: ErrorBannerProps) {
  return (
    <div
      role="alert"
      className={`px-4 py-3 rounded-lg bg-error-light text-error text-sm font-medium ${className}`}
    >
      {message}
    </div>
  )
}
